import React, { Component } from 'react';
// import logo from "../assets/logo_espol_blanco.svg";
import logo from "../assets/logo_espol_interno.svg";

import "../css/CambiarContrasenia.css"
import FormCambiarContrasenia from './components/FormCambiarContrasenia';
import axios from 'axios';
import {Alert} from 'react-bootstrap';
import Modal from '././components/Modal';
import equis from "../assets/eliminar.svg"



export class CambiarContrasenia extends Component {

    constructor(props){
        super(props);

        this.state={
            btnSiguiente:false,
            datosUsuario:{
                correo: "",
                password: ""
            },
            getDatos:{
                token:"",
                username:"",
                id:"",
                rol:"",
                nombres:"",
                apellidos:"",
                correoAlterno:""
            },
            alert:{
                show:false,
                titulo:"",
                mensaje:"",
                variante:""
            },
			modal:{
                show:false,
                titulo:"",
                mensaje:"",
                imagen:""
            },
            expresiones:{
                correo:/^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}([/.]\w{2,})?$/,
            },
            errorSolicitud:{
                correo:"",
                password:"",
            },
        };
        
        this.cambiarEstadoBoton=this.cambiarEstadoBoton.bind(this);
        this.cerrarAlert=this.cerrarAlert.bind(this);
		 this.abrirModal=this.abrirModal.bind(this);
        this.cerrarModal=this.cerrarModal.bind(this);

    }

	
	abrirModal(){
        this.setState({
            modal:{
                ...this.state.modal,
                show:true
            }
        });
    }

    cerrarModal(){
        this.setState({
            modal:{
                titulo:"",
                mensaje:"",
                imagen:"",
                show:false
            }
        });
        //console.log("cerrar modal "+this.state.modal);
    }

    cambiarEstadoBoton(){
        this.setState({btnSiguiente:true});
        //console.log(this.state.btnSiguiente);
    }

    handlerLogin=async(e)=>{
        await this.setState({
            datosUsuario:{
                ...this.state.datosUsuario,
                [e.target.name]:e.target.value,
            }
        })
        //console.log(this.state.datosUsuario);
        this.handlerOnBlur();

    }

    handlerOnBlur=async()=>{

        /*if(this.state.datosUsuario.correo===""){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo: "El campo 'Correo' es requerido"
            }})
        }else */
        if(!this.state.expresiones.correo.test(this.state.datosUsuario.correo)){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo: "El campo 'Correo' no tiene formato correcto"
            }})
        }else{
            this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                correo:""
            }})
        }

        if(this.state.datosUsuario.password===""){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                password: "El campo 'Contraseña' es requerido"
            }})
        }else{
            this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                password:""
            }})
        }

    }


    
    iniciarSesion=async(e)=>{
        e.preventDefault();

        let credenciales ={
            username:this.state.datosUsuario.correo.split("@")[0],
            password:this.state.datosUsuario.password,
            correo:this.state.datosUsuario.correo
        } 

        //console.log(credenciales);

        if(this.state.datosUsuario.correo===""||this.state.datosUsuario.password===""){
            this.setState({
                alert:{
                    show:true,
                    titulo:"Error en la solicitud",
                    mensaje:"Campos vacios",
                    variante:"danger"
                }                
            })
            //console.log("alerta vacios");
        }else{

            await axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/login`,credenciales)
            .then(r=>{
                if(r.status===200){
                    this.setState({
                        getDatos:{
                            token:r.data.token,
                            username:r.data.username,
                            id:r.data.id,
                            rol:r.data.persona.rol,
                            nombres:r.data.persona.nombres,
                            apellidos:r.data.persona.apellidos,
                            correoAlterno:r.data.persona.correoAlterno
                        }
                    })
                    this.setearHeader();
                    this.cambiarEstadoBoton();

                }
                //console.log("iniciando sesion");
                //console.log(this.state.getDatos);
            })
            .catch(error=>{
                this.setState({
                    modal:{
                        show:true,
                        titulo:"Error en la solicitud",
                        mensaje:"correo o contraseña ingresada son incorrectos",
                        imagen:equis
                    }              
                })
                //console.log(error.message);
            })
        }
        
    }

    setearHeader(){
        //console.log("setear header");
        var token = this.state.getDatos.token;
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            axios.defaults.headers.common['Authorization'] = null;
        }
    }

    cerrarAlert(){
        this.setState({
            alert:{
            show:false,
            titulo:"",
            mensaje:""}
        });
    }

    render() {

        return (

            <div className="container-fluid" id="fondo">
                {
                    this.state.alert.show&&
                    <Alert variant={this.state.alert.variante} onClose={this.cerrarAlert} dismissible>
                        <Alert.Heading>{this.state.alert.titulo}</Alert.Heading>
                        <p>
                        {this.state.alert.mensaje}
                        </p>
                    </Alert>
                }

                {this.state.btnSiguiente?
                <FormCambiarContrasenia
                    token={this.state.getDatos.token}
                    id={this.state.getDatos.id}
                    nombres={this.state.getDatos.nombres}
                    apellidos={this.state.getDatos.apellidos}
                    username={this.state.getDatos.username}
                    correo={this.state.datosUsuario.correo}
                >

                </FormCambiarContrasenia>:(
                <div className="cambiarContrasenia-wrapper">
                    <div className="cambiarContrasenia-container" >
                        <div className='cambiarContrasenia-header'>
                            <img className='logo' src={logo} alt="Logo espol" ></img>
							 <h2 id='titulo'>Cambio de Contraseña</h2>
                        </div>
                        <div className="cambiarContrasenia-body">
						
							<h3 align="Center" ><b> Recuerde</b> </h3>
						    <div className='cambiarContrasenia-parrafoAmarillo'>
							
							<ul className="cambiarContrasenia-menulist">
								<li><b>»</b> Para realizar el cambio de contraseña ingrese su correo y contraseña de la cuenta electrónica de ESPOL. </li>
								<li><b>»</b> Si usted ha olvidado su contraseña ingrese a <b><a href="/olvidoContrasenia">¿Olvidó su contraseña?</a></b> </li>
							</ul>
							
							</div>
                            <form onSubmit={this.iniciarSesion}>

                                <div className="mb-3">
                                    <label htmlFor="correo" className="form-label">Usuario:</label>
                                    <input 
                                    type="text" 
                                    required 
                                    className="form-control" 
                                    id="correo" 
                                    placeholder="Correo electrónico" 
                                    name="correo" 
                                    value={this.state.datosUsuario.correo} 
                                    onChange={this.handlerLogin}
                                    onBlur={this.handlerOnBlur}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">Contraseña:</label>
                                    <input 
                                    type="password" 
                                    required 
                                    className="form-control" 
                                    id="password" 
                                    placeholder="Contraseña" 
                                    name="password" 
                                    value={this.state.datosUsuario.password} 
                                    onChange={this.handlerLogin}
                                    onBlur={this.handlerOnBlur}/>
                                </div>
                                
                                <div className="cambiarContrasena-containerIniciarSesion">
                                    <button 
                                    type="submit" 
                                    className="btn-submit-cambiarContrasenia"
                                    disabled={this.state.datosUsuario.correo &&
                                        this.state.datosUsuario.password&&
                                        !this.state.errorSolicitud.correo&&
                                        !this.state.errorSolicitud.password
                                        ? false:true}
                                    >
                                    INICIAR SESIÓN
                                    </button> 
                                </div>
                            </form>
                        </div>
						
						{this.state.modal.show&& 
                        <Modal isOpen={this.state.modal.show} cerrarModal={this.cerrarModal} verBoton={true} textoBoton="ACEPTAR" >
                            <p className='text-center'><strong>{this.state.modal.titulo}</strong></p>
                            <div className='mt-6 mb-6'>
                                <img className="registroContra-check" src={this.state.modal.imagen} alt="Error"></img>
                            </div>

                            <p className='text-center'>{this.state.modal.mensaje}</p>
                            
                        </Modal>}
                        <div className="linea"></div>

                    </div>                             
                </div>)}
            </div>
            
            
        )
    }
}

export default CambiarContrasenia
